export const SUPER_ADMIN = 1;
export const ADMIN = 2;
export const USER = 3;
